import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { NoTelegram } from "../no-telegram";

// Ne plus utiliser directement window.Telegram.WebApp
const Profile = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const handleBackButton = () => {
      navigate('/');
    };
    
    // Telegram est désactivé, donc on ne configure pas le bouton retour
    // Ajouter un gestionnaire d'événements pour le bouton retour du navigateur à la place
    const handleBrowserBack = (e) => {
      e.preventDefault();
      handleBackButton();
    };
    
    window.addEventListener('popstate', handleBrowserBack);
    
    return () => {
      window.removeEventListener('popstate', handleBrowserBack);
    };
  }, [navigate]); // Inclure navigate dans les dépendances
    

  const handleLogout = () => {
 //   setUser({ ...user, isLoggedIn: false });
    navigate("/settings");
  };

  return (
    <div>
      <h1>Profile Page</h1>
      <p>Name: </p>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default Profile;
